import React, {Component} from 'react'
import {Modal, Tabs} from 'antd'
import StandardForm from '../../../components/Main/Standards/StandardForm'
import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import History from '../../../components/Common/History'
import FooterButton from '../../../elements/Buttons/FooterButtons'

const {TabPane} = Tabs

class StandardModal extends Component {
  render() {
    const {
      visible,
      type,
      standard,
      onCancel,
      submitting,
      fetchingTransaction,
      submit,
      formRef,
      update,
      remove,
      removing,
    } = this.props

    const isEdit = type === 'edit'
    const isNew = type !== 'edit'
    return (
      <Modal
        title={isNew ? 'Create Standard' : 'Update Standard'}
        destroyOnClose={true}
        visible={visible}
        onCancel={onCancel}
        width={'95%'}
        footer={
          <FooterButton
            isEdit={type === 'edit'}
            isNew={type === 'new'}
            remove={remove}
            removing={removing}
            submit={submit}
            submitting={submitting}
            update={update}
            title={'Standard'}
          />
        }>
        <Tabs defaultActiveKey="details">
          <TabPane tab="Details" key="details">
            <StandardForm
              ref={formRef}
              loading={fetchingTransaction}
              standard={standard}
              {...this.props}
            />
          </TabPane>
          <TabPane disabled={isNew} tab="History" key="history">
            <History owner={standard} />
          </TabPane>
          <TabPane disabled={isNew} tab="Files" key="files">
            <DocumentsCont
              editable={isEdit}
              footer={false}
              category={false}
              owner={standard}
            />
          </TabPane>
        </Tabs>
      </Modal>
    )
  }
}

StandardModal.propTypes = {}
StandardModal.defaultProps = {standard: {}}

export default StandardModal
